module.exports = __webpack_public_path__ + "img/chn.2cebc310.jpg";